import { css } from '@emotion/react';

import {
  blue100,
  blue500,
  green400,
  orange700,
  red400,
  toothAnatomyEnamel,
  toothAnatomyPulp,
  toothAnatomyScreenBackdrop,
  yellow500,
  yellowGreen100,
} from './videa-style-tokens';

export const annotationStyles = () => css`
  .cornerstoneElement {
    width: 100%;
    height: 100%;
    display: flex;
    & line:not(.user-arrow) {
      stroke-dasharray: 3, 3;
      stroke-width: 0.16em;
      filter: none !important;
    }
    & circle:not(.user-circle) {
      r: 0.145em;
      opacity: 0.88;
      filter: none !important;
    }
    &.mobile-preview {
      & circle:not(.user-circle) {
        r: 0.06em;
      }

      & line.tooth-rbl-red {
        stroke-width: 0.1em;
      }
      & line.tooth-rbl-yellow {
        stroke-width: 0.16em;
      }
      & line.tooth-rbl-orange {
        stroke-width: 0.16em;
      }
      & line.tooth-rbl-green {
        stroke-width: 0.1em;
      }
    }
    & .restorative_adjacent_lucency {
      stroke-dasharray: 3, 2;
      stroke: ${yellowGreen100};
      stroke-width: 0.16em;
      stroke-linejoin: round;
    }
    & .caries {
      stroke: ${red400};
      opacity: 0.8;
      stroke-width: 0.16em;
      &.hovered {
        stroke: ${blue100};
      }
    }
    & .monitored {
      stroke: ${orange700 || '#ff8a1e'};
    }
    & .enamel-only-caries {
      stroke: ${yellow500};
    }
    & line.tooth-rbl-red {
      stroke: ${red400};
      stroke-width: 0.16em;
      stroke-dasharray: 3, 2;
      stroke-linejoin: round;
    }
    & line.tooth-rbl-yellow {
      stroke: ${yellow500};
      stroke-width: 0.16em;
      stroke-dasharray: 3, 2;
      stroke-linejoin: round;
    }
    & line.tooth-rbl-orange {
      stroke: ${orange700 || '#ff8a1e'};
      stroke-width: 0.16em;
      stroke-dasharray: 3, 2;
      stroke-linejoin: round;
    }
    & line.tooth-rbl-green {
      stroke: ${green400};
      stroke-width: 0.16em;
      stroke-dasharray: 3, 2;
      stroke-linejoin: round;
    }
    & line.user-arrow {
      stroke: ${blue500};
      stroke-width: 0.26em;
      stroke-linecap: round;
    }
    & circle.user-circle {
      stroke: ${blue500};
      stroke-width: 0.26em;
    }
    & polyline.user-polyline {
      stroke: ${blue500};
      stroke-width: 0.26em;
    }
    &.thumbnail-view {
      & circle {
        stroke-width: 0;
        r: 0.1em;
        filter: none !important;
      }
      & line:not(.user-arrow) {
        stroke-dasharray: 3, 2;
        stroke-width: 0.06em;
        filter: none !important;
      }
      & rect {
        stroke-width: 0.08em;
      }
      & ellipse {
        stroke-width: 0.088em;
        stroke-dasharray: 6, 0;
        opacity: 0.5;
        box-shadow: none;
      }
      & .restorative_adjacent_lucency {
        stroke-dasharray: 4, 0;
        stroke: ${yellowGreen100};
        stroke-width: 0.06em;
        stroke-linejoin: round;
      }
    }
    &.tooth-parts {
      & [stroke='enamel'] {
        stroke-width: 0;
        fill: ${toothAnatomyEnamel};
        z-index: 2;
        pointer-events: none;
      }
      & [stroke='pulp'] {
        stroke-width: 0;
        fill: ${toothAnatomyPulp};
        z-index: 2;
        pointer-events: none;
      }
      &:not(.patient-download) {
        & .viewport-element {
          position: relative;
          &:after {
            content: '';
            position: absolute;
            top: 1px;
            left: 1px;
            right: 1px;
            bottom: 1px;
            background-color: ${toothAnatomyScreenBackdrop};
            mix-blend-mode: multiply;
            pointer-events: none;
          }
        }
      }
      & polyline:not(.user-polyline) {
        stroke-width: 0;
      }
    }

    &.patient-view {
      & [stroke='caries'] {
        stroke-width: 0;
        fill: rgba(255, 80, 95, 0.77);
        z-index: 2;
        &.monitored {
          fill: ${orange700 || '#ff8a1e'};
          fill-opacity: 0.77;
        }
      }
      & [stroke='periapical_radiolucency'] {
        stroke-width: 0;
        fill: #bb004366;
        z-index: 2;
        &.monitored {
          fill: ${orange700 || '#ff8a1e'};
          fill-opacity: 0.66;
        }
      }
      & [stroke='restorative_adjacent_lucency'] {
        stroke-width: 0;
        fill: url(#ral-fill);
        z-index: 3;
      }
      & [stroke='enamel-only-caries'] {
        stroke-width: 0;
        fill: rgba(255, 222, 56, 0.75);
        z-index: 10;
        &.monitored {
          fill: ${orange700 || '#ff8a1e'};
          fill-opacity: 0.75;
        }
      }
      & [stroke='calculus'] {
        stroke-width: 0;
        fill: url(#calculus-fill);
        z-index: 2;
      }
      & .cornerstone-canvas {
        z-index: 0;
      }
      & .svg-layer {
        z-index: 2;
      }
    }
    .user-polyline {
      stroke-width: 0.16em;
      z-index: 5;
    }
  }
`;
